<template>
  <div class="card" :style="cardStyle">
    <div v-if="inprogress" class="text-center text-black my-5">
      <h4>{{ text }} {{ $t('strategytxt') }}. {{ $t('pleasewait') }}</h4>
      <i class="fa fa-spinner fa-spin fa-fw" style="font-size: 60px;"></i>
    </div>
    <div v-else class="card-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardWrapper',
  props: ['inprogress', 'text'],
  computed: {
    cardStyle() {
      return {
        backgroundColor: '#f4f3ef',
        borderRadius: '20px',
        marginTop: this.inprogress ? null : '15px',
      };
    },
  },
};
</script>
